import * as React from "react";
import { observer } from "mobx-react";
import { authStore } from '../auth';

@observer
class BlockedPermission extends React.Component<any> {
    
    public render() {

        if (authStore.currentUser.Verified === 0) {
            window.location.replace('/password-verify');
        }
        
        return (<div>This page is unavailable. <a href="/dashboard">Back to Dashboard</a></div>)
    }
}

export default BlockedPermission



// WEBPACK FOOTER //
// ./src/modules/portal/BlockedPermission.tsx